export const USERS_EMPLOYER_COMPANY_BANNER_REMOVE_REQUEST =
  'users/employer-company-banner-remove-request'
export const USERS_EMPLOYER_COMPANY_BANNER_REMOVE_SUCCESS =
  'users/employer-company-banner-remove-success'
export const USERS_EMPLOYER_COMPANY_BANNER_REMOVE_FAILED =
  'users/employer-company-banner-remove-failed'
